import { DRIFT_CHAT_BIONIC_RATED_MESSAGES_MEASURES } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for bionic ratings count.
 */
export const BionicRatingsCountQuery: CubeQuery = {
  name: 'BionicRatingsCountQuery',
  queryName: DRIFT_CHAT_BIONIC_RATED_MESSAGES_MEASURES.RATINGS_COUNT,
  query: {
    measures: [DRIFT_CHAT_BIONIC_RATED_MESSAGES_MEASURES.RATINGS_COUNT],
  },
}
